import i18n from "@/i18n";

import { CustomFilter } from "@/types/custom-filter";

import { FalconComplaintState } from "@/enums/falcon/complaints/falcon-complaint-state.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon complaint state filter
 */
export const falconComplaintStateFilter: CustomFilter = {
  falconComplaintState(value: any): string {
    value = +value as FalconComplaintState;
    if (value === FalconComplaintState.Closed) {
      value = i18n.t(I18nMessageKey.SharedFiltersComplaintStateClosedText);
    } else if (value === FalconComplaintState.Open) {
      value = i18n.t(I18nMessageKey.SharedFiltersComplaintStateOpenText);
    } else if (value === FalconComplaintState.Terminal) {
      value = i18n.t(I18nMessageKey.SharedFiltersComplaintStateTerminalText);
    } else {
      value = "";
    }
    return value;
  }
};
